import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getWebhookById } from "../../api/apiWebhooks";

export const useGetWebhookById = (id) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["webhooks", id, i18next.language],
        queryFn: () => getWebhookById(id),
        enabled: Boolean(id),
    });

    // Backend may return either { data: {...} } or the resource object directly.
    const webhook = data?.data && typeof data.data === 'object'
        ? data.data
        : (data && typeof data === 'object' && !Array.isArray(data) ? data : null);

    return { webhook, isLoading, error, refetch };
};
